import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Container, Divider, Button, Typography, InputBase } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { Search, Sort } from '@mui/icons-material';

import { ForecastList } from "../components/ForecastList";

import { selectProjects } from '../reducers/projectSlice';

import { NewList } from '../components/NewList';
import { selectUser } from '../reducers/userSlice';
import NewListSplitButton from '../components/NewListSplitButton';
import { PetroNinjaList } from '../components/PetroNinjaList';
import { selectLists } from '../reducers/listSlice';


const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: 'red',
    // backgroundColor: theme.palette.backgroundOne,
    // backgroundColor: theme.palette.grey[100],
    flexBasis: 320,
    flexShrink: 0,
    flexGrow: 0,
    height: 'calc(100% - 20px)',
    marginTop: 20,
    padding: 10,
    overflowY: 'auto',
    overflowX: 'hidden',
    // borderRight: '1px solid lightgrey'
  },
  listsButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 10
  },
  button: {
    borderRadius: 20
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    marginBottom: 5,
    paddingLeft: 5,
    // border: `1px solid ${theme.palette.primary.main}`,
    height: 36,
  },
  searchIcon: {
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // color: theme.palette.primary.main
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    // vertical padding + font size from searchIcon
    paddingLeft: 24,
  },
  emptyForecast: {
    width: '100%',
    height: '80%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export const ForecastListContainer = () => {
  const classes = useStyles();
  const theme = useTheme();

  const projects = useSelector(selectProjects);
  const lists = useSelector(selectLists);
  const user = useSelector(selectUser);

  const [searchList, setSearchList] = useState("");
  const [newListOpen, setNewListOpen] = useState(false);
  const [pnListOpen, setPNListOpen] = useState(false);
  const [sortDesc, setSortDesc] = useState(true);
  const [expandAll, setExpandAll] = useState(true);

  const projectId = projects?.currentProjectId || 'default';
  let listIds = projects?.byId?.[projectId]?.listIds ? [...projects?.byId?.[projectId]?.listIds] : [];
  if (searchList.length > 0) listIds = listIds.filter(listId => lists?.byId?.[listId]?.name?.toLowerCase()?.includes(searchList.toLowerCase()));
  if (sortDesc) {
    listIds = listIds?.reverse();
  };

  const darkMode = user?.value?.darkMode;
  const demoUser = user?.value?.subscription === 'Demo';


  function handleNewListClick() {
    setNewListOpen(true);
  };

  function handleNewListClose() {
    setNewListOpen(false);
  };

  function handleSort() {
    setSortDesc(!sortDesc);
  };

  try {
    return (
      <Container className={classes.root} style={{
        backgroundColor: theme?.palette?.paper?.[darkMode ? 'dark' : 'light'],
        borderRight: `1px solid ${darkMode ? 'dimgrey' : 'lightgrey'}`
      }}>
        {newListOpen && <NewList 
          handleNewListClose={handleNewListClose} 
          projectId={projectId}
          userEmail={user.value.email}
          darkMode={darkMode}
        />}
        {pnListOpen && <PetroNinjaList 
        handlePNListClose={handlePNListClose}
        projectId={projectId}
        userEmail={user.value.email}
        darkMode={darkMode}
      />}
        <div id="forecast-header" style={{display: 'flex', flexDirection: 'column'}}>
          <Typography variant="h6" color="textSecondary" style={{fontSize: 14}}>
            WELL LISTS
          </Typography>
          <Typography variant="h5" className={classes.projectName} noWrap>
            {projects?.byId?.[projectId]?.name || "Default Project"}
          </Typography>
        </div>
  
        <div className={classes.listsButtons}>
          <NewListSplitButton handleNewListClick={handleNewListClick} handlePNListClick={handlePNListClick} darkMode={darkMode} demoUser={demoUser} />
          <div>
            <Button startIcon={<Sort /> } onClick={handleSort} color={darkMode ? "inherit" : "primary"} size="small">
              Sort
            </Button>
          </div>
        </div>
  
        <div className={classes.search} style={{border: `1px solid ${darkMode ? "lightgrey" : theme.palette.primary.main}`}}>
          <div className={classes.searchIcon}>
            <Search color={darkMode ? "inherit" : "primary"} />
          </div>
          <InputBase
            placeholder="Search lists by name"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            value={searchList}
            onChange={handleListSearch}
          />
        </div>

        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Typography fontSize={'12px'} style={{marginBottom: 5}}>{`Lists: ${listIds?.length || 0} | Sorted by: ${sortDesc ? 'newest' : 'oldest'}`}</Typography>
          <Button color={darkMode ? "inherit" : "primary"} size="small" onClick={() => setExpandAll(prev => !prev)}><Typography fontSize={10}>{expandAll ? 'Collapse' : 'Expand'} All</Typography></Button>
        </div>
  
        <Divider />
  
        {listIds?.length > 0 ? <div className={classes.lists}>  
          {listIds.map(listId => {
            return (
              <ForecastList
                projectId={projectId}
                listId={listId}
                key={listId}
                expandAll={expandAll}
              />
            )
          })}
        </div>
        :
        <div className={classes.emptyForecast}>
          <Typography variant="subtitle" color="textSecondary" textAlign="center">Create new list to get started</Typography>
        </div>
        }
  
      </Container>
    );  
  } catch (error) {
    console.log(error);
    return <></>;
  };

  // FUNCTIONS
  function handleListSearch(e) {
    setSearchList(e.target.value);
  };

  function handlePNListClick() {
    setPNListOpen(true);
  };

  function handlePNListClose() {
    setPNListOpen(false);
  };  
  
}


